export const ROUTES = {
  home: '/',
  blog: '/blog',
  about: '/about',
  locations: '/locations',
  contact: '/contact',
  faqs: '/faqs',
  returns: '/return-refund',
  privacy: '/privacy',
  terms: '/terms',
  disclaimer: '/disclaimer',
  vendorRegistration: '/vendor-registration',
  corporateEnquiry: '/corporate-enquiry',
} as const

export const SHOP_ROUTES = {
  flowers: '/shop/flowers',
  plants: '/shop/plants',
  flowerChocolateCombo: '/shop/flower-chocolate-combo',
  occasions: '/shop/occasions',
} as const
